import { useEffect, useState } from "react";
import Modal from "react-responsive-modal";
import PaymentServices from "../PaymentServices";
import picture from '../../../assets/images/tipalti.png';
import { useLocation } from "react-router-dom";
import cachingMechanisum from "../../Common/cachingMechanisum";

export default function AuthInitialisation(param: any) {

    let [openFirst, setOpenFirst] = useState(false);
    let [authInitialisationList, SetauthInitialisationList] = useState<any>([]);
    let [ClientDetailsList, SetClientDetails] = useState<any>([]);
    let [tipalTiRespond, SetTipalTiRespond] = useState<string>("");
    let [tipaltiScopes, SettipaltiScopes] = useState([
        { selection: true, value: 'tipalti.api.payee.read' },
        { selection: true, value: 'tipalti.api.payee.write' },
        { selection: true, value: 'tipalti.api.payer-entity.read' },
        { selection: true, value: 'tipalti.api.report1099.write' },
        { selection: true, value: 'tipalti.api.report1099.read' },
        { selection: true, value: 'tipalti.api.report1042.write' },
        { selection: true, value: 'tipalti.api.report1042.read' },
        { selection: true, value: 'tipalti.api.payment-batch.write' },
        { selection: true, value: 'tipalti.api.payment-batch.read' },
        { selection: true, value: 'tipalti.api.payment.read' },
        { selection: true, value: 'tipalti.api.gl-account.read' },
        { selection: true, value: 'tipalti.api.tax-code.read' },
        { selection: true, value: 'tipalti.api.invoice.read' },
        { selection: true, value: 'tipalti.api.custom-field.read' },
        { selection: true, value: 'tipalti.api.invoice-batch.read' },
        { selection: true, value: 'tipalti.api.invoice-batch.write' }
    ]);

    let [clientDetailList, setclientDetailList] = useState<any>([]);
    useEffect(() => {

        clientDetailList = cachingMechanisum.getCachingStorage("ClientDetails");
        console.log(param);
        console.log(window.location);

        if (window.location.pathname === "/tipalti") {
            console.log('a');
            if (window.location.search) {
                console.log('d');
                tipaltiInitCheck(); 
                //setOpenFirst(true);
                apiCall();

            } else {
                console.log('e');
                //setOpenFirst(true); /*setTimeout(function(){ }, 1000);*/ 
                apiCall();
            }
        } else {
            console.log('b');
            //setOpenFirst(true);
            apiCall();
        }



        /*
        
                if (param && param.openUI && !openFirst) {
                    openFirst = true;
                    setOpenFirst(openFirst);
                    apiCall();
        
                    if (window.location.pathname === "/tipalti" && window.location.search && global.tipaltiFix !== window.location.search) {
                        global.tipaltiFix = window.location.search;
                        tipaltiInitCheck();
                    }
                }
        */

    }, []);

    const authInitialisation = () => {

        clientDetailList = cachingMechanisum.getCachingStorage("ClientDetails");
        if (clientDetailList) {
            PaymentServices.authInitialisation({ mainLabelCo: clientDetailList?.mainLabelCo }).then((values: any) => {
                authInitialisationList = values;
                SetauthInitialisationList(authInitialisationList)
            })
        }
        /*PaymentServices.getClientDetails().then((values: any) => {
            global.clientDetail = values[0];
            PaymentServices.authInitialisation({ mainLabelCo: global.clientDetail?.mainLabelCo }).then((values: any) => {
                authInitialisationList = values;
                SetauthInitialisationList(authInitialisationList)
            })
        })*/



    };

    const authoriseTipalti = () => {
        authInitialisationList.scope = '';

        var tempScope = ""
        for (var i = 0; i < tipaltiScopes.length; i++) {
            if (tipaltiScopes[i].selection) {

                tempScope = tempScope + tipaltiScopes[i].value + ' ';
            }
        }
        authInitialisationList.scope = tempScope;

        PaymentServices.authoriseTipalti(authInitialisationList).then(function (data) {

            //console.log(data);
            window.open(data, "_self");
        });
    };

    const updateField = (value: any, filedName: any) => {
        //console.log(value)
        //console.log(filedName)
        //console.log(authInitialisationList[filedName])
        SetauthInitialisationList({ ...authInitialisationList, ...{ [filedName]: value } });
    };

    const updateCheckBox = (index: number) => {
        const updatedScopes = [...tipaltiScopes];  // Create a shallow copy of the array
        updatedScopes[index].selection = !updatedScopes[index].selection;  // Toggle the selection property
        SettipaltiScopes(updatedScopes);  // Update the state with the new array
    };

    const apiCall = () => { 

        if (clientDetailList) {
            PaymentServices.paymentVendor({ mainLabelCo: clientDetailList?.mainLabelCo }).then((values: any) => {
                SetauthInitialisationList(values[0]);
                setOpenFirst(true);
            })
        } else {

            PaymentServices.getClientDetails().then((values: any) => {
                clientDetailList = values[0];
                if (values && values[0] && values[0].mainLabelCo) {
                    PaymentServices.paymentVendor({ mainLabelCo: clientDetailList?.mainLabelCo }).then((values: any) => {
                        SetauthInitialisationList(values[0]);
                        setOpenFirst(true);
                    })
                }
            })

        }


        /*
                if (window.location.search.length === 0) {
                    global.tipalTiRespond = ""
                    localStorage.removeItem('msgTipalti');
                }
        
                var naming = localStorage?.getItem('msgTipalti') ? localStorage?.getItem('msgTipalti') : '';
                if (window.location.search.length > 0 && naming && naming.length > 0) {
                    global.tipalTiRespond = localStorage?.getItem('msgTipalti');
                }
        
        */

    };




    const tipaltiInitCheck = () => {

        PaymentServices.tipaltiInitCheck(window.location.search).then((value: any) => {
            console.log(value);
            if (value) {
                localStorage.setItem('msgTipalti', value);
                global.tipalTiRespond = value;
                window.open((window.location.origin + window.location.pathname), "_self");
            }


            /*
                        if (typeof value === "string") {
            
                            //tipalTiRespond = value;
                            SetTipalTiRespond((value) => value);
                        }
            
                        if (typeof value === "object") {
                            const stringified = JSON.stringify(value, null, 2);
                            //tipalTiRespond = stringified;
                            SetTipalTiRespond((value) => value)
                        }
            
                        console.log(tipalTiRespond);
                        localStorage.setItem('msgTipalti', tipalTiRespond);
            
                        global.tipalTiRespond = tipalTiRespond;
            */
        })
    }

    const closeUI = () => {
        setOpenFirst(false);
        param.closeUI(false);
    }


    return (
        <div>
            <Modal open={openFirst} onClose={() => closeUI()} center>
                <div className="box-header-main">
                    <h2>Tipalti Initialise Payment</h2>
                </div>

                <div className="box-content">


                    <div className="ws-12">
                        {!authInitialisationList?.webhookUrl && <label className="centerWindow ws-6 pLarge bg-level2 borderRounded ">
                            <span className="ws-12  text-center mbl">
                                Begin by onboarding suppliers through Tipalti's portal, collecting payment details, tax forms, and integrating with Korrect Royalty System.
                            </span>
                            <a className="icon-btn edit pull-none centerWindow" onClick={() => authInitialisation()} style={{ "display": "table" }}>
                                Initialise
                            </a>
                        </label>}
                    </div>

                    {!authInitialisationList?.webhookUrl && false && <label>
                        Begin by onboarding suppliers through Tipalti's portal, collecting payment details, tax forms, and integrating with Korrect Royalty System.
                        <a className="icon-btn edit" onClick={() => authInitialisation()}>  Initialise  </a>
                    </label>}

                    {authInitialisationList?.webhookUrl && <div >

                        <div className="form-format ws-6 hide">
                            <label>Webhook URL</label>
                            <div className="label-entries">
                                <input type="text" placeholder="webhookUrl" name="webhookUrl" readOnly value={authInitialisationList?.webhookUrl ? authInitialisationList.webhookUrl : ''} onChange={(e: any) => updateField(e.target.value, "webhookUrl")} />
                            </div>
                        </div>

                        <div className="form-format ws-6">
                            <label>Return URL</label>
                            <div className="label-entries">
                                <input type="text" placeholder="returnUrl" name="returnUrl" readOnly value={authInitialisationList?.returnUrl ? authInitialisationList.returnUrl : ''} onChange={(e: any) => updateField(e.target.value, "returnUrl")} />
                            </div>
                        </div>


                        <div className="form-format ws-6">
                            <label>Payer Name</label>
                            <div className="label-entries">
                                <input type="text" placeholder="PayerName" name="PayerName" value={authInitialisationList?.instanceName ? authInitialisationList.instanceName : ''} onChange={(e: any) => updateField(e.target.value, "instanceName")} />
                            </div>
                        </div>


                        {(!authInitialisationList?.webhookUrl) && <div className="ws-12 mtl ptl">
                            <label className="centerWindow ws-6 pLarge bg-level2 borderRounded " ng-show="tipaltiResponseDetails.webhookUrl">
                                <span className="ws-12  text-center mbl">
                                    To initiate Tipalti API integration, obtain your Client ID and Secret from Tipalti Hub
                                </span>

                                <a className="icon-btn edit pull-none centerWindow" style={{ "display": "table" }} href="https://developer.sandbox.tipalti.com" target="_blank">  Tipalti Hub  </a>

                            </label>
                        </div>
                        }




                        <div className="form-format ws-6 hide">
                            <label>Client ID</label>
                            <div className="label-entries">
                                <input type="text" placeholder="clientId" name="clientId" value={authInitialisationList?.clientId ? authInitialisationList.clientId : ''} onChange={(e: any) => updateField(e.target.value, "clientId")} />
                            </div>
                        </div>

                        <div className="form-format ws-6 hide">
                            <label>Client Secret</label>
                            <div className="label-entries">
                                <input type="text" placeholder="clientSecret" name="clientSecret" value={authInitialisationList?.clientSecret ? authInitialisationList.clientSecret : ''} onChange={(e: any) => updateField(e.target.value, "clientSecret")} />
                            </div>
                        </div>


                        <div className="ws-12 mtl pLarge hide">
                            <h2 className="ws-12 mbl">Scope</h2>
                            {tipaltiScopes?.map((values: any, index: any) => {

                                return (
                                    <div className="ws-3 pm">
                                        <input type="checkbox" ng-model="tipaltiScope.selection" value={values?.selection} checked={values?.selection} onChange={() => updateCheckBox(index)} /> {values.value}
                                    </div>
                                )
                            })}
                        </div>


                        <div className="ws-12 mt">
                            {authInitialisationList?.webhookUrl &&
                                <div className="centerWindow ws-6">
                                    <div className="ws-12 bg-level2 pLarge borderRounded">
                                        <span className="ws-12  text-center mbl">Connect to Tipalti's portal with Korrect Royalty System.</span>
                                        {
                                            <div className="ws-12">
                                                <a className="icon-btn edit pull-none centerWindow" onClick={authoriseTipalti} style={{ "display": "table" }}>
                                                    <span className="pm pull-left mrl">Connect</span>
                                                    <img alt="Korrect"  className="pull-right mll" height="30px" src={picture} />
                                                </a>
                                            </div>
                                        }

                                        {global.tipalTiRespond && <span className="text-center ws-12 mtl plarge">{global.tipalTiRespond}</span>}
                                        {<span className="text-center ws-12 plarge mtl">{localStorage?.getItem('msgTipalti')}</span>}

                                    </div>
                                </div>}
                        </div>

                    </div>}

                </div>

                <div className="box-footer">
                    <a className="icon-btn delete" onClick={() => setOpenFirst(false)}>  Close  </a>

                    {false && authInitialisationList?.webhookUrl && authInitialisationList?.clientSecret !== null && authInitialisationList?.clientId !== null && <a className="icon-btn edit" onClick={authoriseTipalti}> Connect</a>}

                    {false && authInitialisationList?.webhookUrl && <a className="icon-btn edit" href="https://developer.sandbox.tipalti.com" target="_blank">Tipalti Hub </a>}
                </div>

            </Modal>
        </div>
    );


    /*
    const { search } = useLocation();

    let [openFirst, setOpenFirst] = useState(false);
    let [flag, setFlag] = useState<boolean>(false);
    let [ClientDetailsList, SetClientDetails] = useState<any>([]);
    let [tipalTiRespond, SetTipalTiRespond] = useState<string>("");
    let [authInitialisationList, SetauthInitialisationList] = useState<any>([]);

    let [tipaltiScopes, SettipaltiScopes] = useState([
        { selection: true, value: 'tipalti.api.payee.read' },
        { selection: true, value: 'tipalti.api.payee.write' },
        { selection: true, value: 'tipalti.api.payer-entity.read' },
        { selection: true, value: 'tipalti.api.report1099.write' },
        { selection: true, value: 'tipalti.api.report1099.read' },
        { selection: true, value: 'tipalti.api.report1042.write' },
        { selection: true, value: 'tipalti.api.report1042.read' },
        { selection: true, value: 'tipalti.api.payment-batch.write' },
        { selection: true, value: 'tipalti.api.payment-batch.read' },
        { selection: true, value: 'tipalti.api.payment.read' },
        { selection: true, value: 'tipalti.api.gl-account.read' },
        { selection: true, value: 'tipalti.api.tax-code.read' },
        { selection: true, value: 'tipalti.api.invoice.read' },
        { selection: true, value: 'tipalti.api.custom-field.read' },
        { selection: true, value: 'tipalti.api.invoice-batch.read' },
        { selection: true, value: 'tipalti.api.invoice-batch.write' }
    ]);

    useEffect(() => {

        console.log("param change")
        console.log(param);

        if (param && param.openUI && !openFirst) {
            openFirst = true;
            setOpenFirst(openFirst);
            apiCall();

            if (window.location.pathname === "/tipalti" && window.location.search && global.tipaltiFix !== window.location.search) {
                global.tipaltiFix = window.location.search;
                tipaltiInitCheck();
            }
        }

    }, [param]);

    const tipaltiInitCheck = () => {

        PaymentServices.tipaltiInitCheck(window.location.search).then((value: any) => {

            if (typeof value === "string") {

                tipalTiRespond = value;
                SetTipalTiRespond((value) => value)
            }

            if (typeof value === "object") {
                const stringified = JSON.stringify(value, null, 2);
                tipalTiRespond = stringified;
                SetTipalTiRespond((value) => value)
            }

            localStorage.setItem('msgTipalti', tipalTiRespond);

            global.tipalTiRespond = tipalTiRespond;

        })
    }

    const apiCall = () => {
        //console.log(global.clientDetail)

        if (window.location.search.length === 0) {
            global.tipalTiRespond = ""
            localStorage.removeItem('msgTipalti');
        }

        var naming = localStorage?.getItem('msgTipalti') ? localStorage?.getItem('msgTipalti') : '';
        if (window.location.search.length > 0 && naming && naming.length > 0) {
            global.tipalTiRespond = localStorage?.getItem('msgTipalti');
        }


        if (global.clientDetail && openFirst === true) {
            SetClientDetails(global.clientDetail)
            //authInitialisation();
            PaymentServices.paymentVendor({ mainLabelCo: global.clientDetail?.mainLabelCo }).then((values: any) => {
                //console.log(values)
                authInitialisationList = values[0];
                SetauthInitialisationList(authInitialisationList)
            })
        } else {
            PaymentServices.getClientDetails().then((values: any) => {
                global.clientDetail = values[0];
                SetClientDetails(values[0])
                if (values && values[0] && values[0].mainLabelCo) {
                    PaymentServices.paymentVendor({ mainLabelCo: global.clientDetail?.mainLabelCo }).then((values: any) => {
                        //console.log(values)
                        authInitialisationList = values[0];
                        SetauthInitialisationList(authInitialisationList)
                    })
                }
            })
        }
    };

    const authInitialisation = () => {

        PaymentServices.authInitialisation({ mainLabelCo: ClientDetailsList?.mainLabelCo }).then((values: any) => {
            authInitialisationList = values;
            SetauthInitialisationList(authInitialisationList)
        })

    };

    const authoriseTipalti = () => {
        authInitialisationList.scope = '';

        var tempScope = ""
        for (var i = 0; i < tipaltiScopes.length; i++) {
            if (tipaltiScopes[i].selection) {

                tempScope = tempScope + tipaltiScopes[i].value + ' ';
            }
        }
        authInitialisationList.scope = tempScope;

        PaymentServices.authoriseTipalti(authInitialisationList).then(function (data) {

            //console.log(data);
            window.open(data, "_self");
        });
    };

    const updateField = (value: any, filedName: any) => {
        //console.log(value)
        //console.log(filedName)
        //console.log(authInitialisationList[filedName])
        SetauthInitialisationList({ ...authInitialisationList, ...{ [filedName]: value } });
    };

    const updateCheckBox = (index: number) => {
        const updatedScopes = [...tipaltiScopes];  // Create a shallow copy of the array
        updatedScopes[index].selection = !updatedScopes[index].selection;  // Toggle the selection property
        SettipaltiScopes(updatedScopes);  // Update the state with the new array
    };

*/
    /*
        return (<>
    
            <div className={"box-primary ms text-center iconLogo pull-left mll mrl hide"}>
                <i className="box icon-dollar1" onClick={() => { setOpenFirst(true); apiCall(); }}></i>
                <span className="m0 pts ">Tipalti</span>
            </div>
    
            <Modal open={openFirst} onClose={() => setOpenFirst(false)} center>
                <div className="box-header-main">
                    <h2>Tipalti Initialise Payment</h2>
                </div>
    
                <div className="box-content">
    
    
                    <div className="ws-12">
                        {!authInitialisationList?.codeVerifier && <label className="centerWindow ws-6 pLarge bg-level2 borderRounded ">
                            <span className="ws-12  text-center mbl">
                                Begin by onboarding suppliers through Tipalti's portal, collecting payment details, tax forms, and integrating with Korrect Royalty System.
                            </span>
                            <a className="icon-btn edit pull-none centerWindow" onClick={() => authInitialisation()} style={{ "display": "table" }}>
                                Initialise
                            </a>
                        </label>}
                    </div>
    
                    {!authInitialisationList?.codeVerifier && false && <label>
                        Begin by onboarding suppliers through Tipalti's portal, collecting payment details, tax forms, and integrating with Korrect Royalty System.
                        <a className="icon-btn edit" onClick={() => authInitialisation()}>  Initialise  </a>
                    </label>}
    
                    {authInitialisationList?.codeVerifier && <div >
    
                        <div className="form-format ws-6">
                            <label>Webhook URL</label>
                            <div className="label-entries">
                                <input type="text" placeholder="webhookUrl" name="webhookUrl" readOnly value={authInitialisationList?.webhookUrl ? authInitialisationList.webhookUrl : ''} onChange={(e: any) => updateField(e.target.value, "webhookUrl")} />
                            </div>
                        </div>
    
                        <div className="form-format ws-6">
                            <label>Return URL</label>
                            <div className="label-entries">
                                <input type="text" placeholder="returnUrl" name="returnUrl" readOnly value={authInitialisationList?.returnUrl ? authInitialisationList.returnUrl : ''} onChange={(e: any) => updateField(e.target.value, "returnUrl")} />
                            </div>
                        </div>
    
                        <div className="ws-12 mtl ptl">
                            <label className="centerWindow ws-6 pLarge bg-level2 borderRounded " ng-show="tipaltiResponseDetails.codeVerifier">
                                <span className="ws-12  text-center mbl">
                                    To initiate Tipalti API integration, obtain your Client ID and Secret from Tipalti Hub
                                </span>
    
                                <a className="icon-btn edit pull-none centerWindow" style={{ "display": "table" }} href="https://developer.sandbox.tipalti.com" target="_blank">  Tipalti Hub  </a>
    
                            </label>
                        </div>
    
                        <div className="form-format ws-6">
                            <label>Client ID</label>
                            <div className="label-entries">
                                <input type="text" placeholder="clientId" name="clientId" value={authInitialisationList?.clientId ? authInitialisationList.clientId : ''} onChange={(e: any) => updateField(e.target.value, "clientId")} />
                            </div>
                        </div>
    
                        <div className="form-format ws-6">
                            <label>Client Secret</label>
                            <div className="label-entries">
                                <input type="text" placeholder="clientSecret" name="clientSecret" value={authInitialisationList?.clientSecret ? authInitialisationList.clientSecret : ''} onChange={(e: any) => updateField(e.target.value, "clientSecret")} />
                            </div>
                        </div>
    
                        <div className="form-format ws-6">
                            <label>Payer Name</label>
                            <div className="label-entries">
                                <input type="text" placeholder="PayerName" name="PayerName" value={authInitialisationList?.instanceName ? authInitialisationList.instanceName : ''} onChange={(e: any) => updateField(e.target.value, "instanceName")} />
                            </div>
                        </div>
    
                        <div className="ws-12 mtl pLarge">
                            <h2 className="ws-12 mbl">Scope</h2>
                            {tipaltiScopes?.map((values: any, index: any) => {
    
                                return (
                                    <div className="ws-3 pm">
                                        <input type="checkbox" ng-model="tipaltiScope.selection" value={values?.selection} checked={values?.selection} onChange={() => updateCheckBox(index)} /> {values.value}
                                    </div>
                                )
                            })}
                        </div>
    
    
                        <div className="ws-12 mt">
                            {authInitialisationList?.codeVerifier && authInitialisationList.clientSecret !== null && authInitialisationList.clientId !== null &&
                                <div className="centerWindow ws-6">
                                    <div className="ws-12 bg-level2 pLarge borderRounded">
                                        <span className="ws-12  text-center mbl">Connect to Tipalti's portal with Korrect Royalty System.</span>
                                        {
                                            <div className="ws-12">
                                                <a className="icon-btn edit pull-none centerWindow" onClick={authoriseTipalti} style={{ "display": "table" }}>
                                                    <span className="pm pull-left mrl">Connect</span>
                                                    <img alt="Korrect"  className="pull-right mll" height="30px" src={picture} />
                                                </a>
    
                                            </div>
                                        }
                                        {global.tipalTiRespond && <span className="text-center ws-12 plarge mtl">{global.tipalTiRespond}</span>}                                                                            
                                        
                                    </div>
                                </div>}
                        </div>
    
                    </div>}
    
                </div>
    
                <div className="box-footer">
                    <a className="icon-btn delete" onClick={() => setOpenFirst(false)}>  Close  </a>
    
                    {false && authInitialisationList?.codeVerifier && authInitialisationList?.clientSecret !== null && authInitialisationList?.clientId !== null && <a className="icon-btn edit" onClick={authoriseTipalti}> Connect</a>}
    
                    {false && authInitialisationList?.codeVerifier && <a className="icon-btn edit" href="https://developer.sandbox.tipalti.com" target="_blank">Tipalti Hub </a>}
                </div>
    
            </Modal>
        </>)
        */
}